import request from "@/utils/request";
export const getProductList = () => {
    return request.get("/products/list");
};
export const getProductById = (id) => {
    return request.get(`/products/${id}`);
};
export const saveProduct = (data) => {
    return request.post("/products", data);
};
export const updateProduct = (id, data) => {
    return request.put(`/products/${id}`, data);
};
export const deleteProduct = (id) => {
    return request.delete(`/products/${id}`);
};
